import { timeParse } from 'd3'
const assetStructureChartData = [
  {
      "dateString": "2010-12-31",
      "otherFixed": "65878.17783",
      "nonCashCurrent": "54182.82247",
      "netPPAndE": "51939.86791",
      "CashST": "9159.046582",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  },
  {
      "dateString": "2011-06-30",
      "otherFixed": "69041.37384",
      "nonCashCurrent": "60520.74169",
      "netPPAndE": "58040.5305",
      "CashST": "13312.37259",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  },
  {
      "dateString": "2011-12-31",
      "otherFixed": "78657.67832",
      "nonCashCurrent": "72266.05389",
      "netPPAndE": "67914.39684",
      "CashST": "19375.58555",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  },
  {
      "dateString": "2012-06-30",
      "otherFixed": "73221.73191",
      "nonCashCurrent": "66792.17203",
      "netPPAndE": "61277.88942",
      "CashST": "10582.25159",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  },
  {
      "dateString": "2012-12-31",
      "otherFixed": "80511.79161",
      "nonCashCurrent": "72892.35727",
      "netPPAndE": "66731.89643",
      "CashST": "15136.58071",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  },
  {
      "dateString": "2013-06-30",
      "otherFixed": "78151.7571",
      "nonCashCurrent": "70619.31741",
      "netPPAndE": "64213.07647",
      "CashST": "12751.82722",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  },
  {
      "dateString": "2013-12-31",
      "otherFixed": "88900.62062",
      "nonCashCurrent": "81460.70366",
      "netPPAndE": "74991.85083",
      "CashST": "22866.59963",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  },
  {
      "dateString": "2014-06-30",
      "otherFixed": "77805.47689",
      "nonCashCurrent": "70207.28176",
      "netPPAndE": "64829.70916",
      "CashST": "11734.33991",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  },
  {
      "dateString": "2014-12-31",
      "otherFixed": "87998.86607",
      "nonCashCurrent": "78328.89382",
      "netPPAndE": "73320.76516",
      "CashST": "19711.68874",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  },
  {
      "dateString": "2015-06-30",
      "otherFixed": "85491.87308",
      "nonCashCurrent": "75302.43303",
      "netPPAndE": "71069.4477",
      "CashST": "15214.69723",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  },
  {
      "dateString": "2015-12-31",
      "otherFixed": "83482.221",
      "nonCashCurrent": "72716.23963",
      "netPPAndE": "68817.17792",
      "CashST": "10005.4669",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  },
  {
      "dateString": "2016-06-30",
      "otherFixed": "80584.54193",
      "nonCashCurrent": "69495.20408",
      "netPPAndE": "66275.66258",
      "CashST": "5157.52395",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  },
  {
      "dateString": "2016-12-31",
      "otherFixed": "86703.47645",
      "nonCashCurrent": "75686.2503",
      "netPPAndE": "72918.37575",
      "CashST": "10032.5761",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  },
  {
      "dateString": "2017-06-30",
      "otherFixed": "80117.59635",
      "nonCashCurrent": "69282.24375",
      "netPPAndE": "67135.47",
      "CashST": "6174.90195",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  },
  {
      "dateString": "2017-12-31",
      "otherFixed": "83230.7931",
      "nonCashCurrent": "72177.1309",
      "netPPAndE": "69863.2101",
      "CashST": "9771.625",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  },
  {
      "dateString": "2018-06-30",
      "otherFixed": "81161.18025",
      "nonCashCurrent": "75308.47455",
      "netPPAndE": "72688.09425",
      "CashST": "8433.85875",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  },
  {
      "dateString": "2018-12-31",
      "otherFixed": "94406.3023",
      "nonCashCurrent": "88487.3137",
      "netPPAndE": "84737.05505",
      "CashST": "21053.12215",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  },
  {
      "dateString": "2019-06-30",
      "otherFixed": "86656.25",
      "nonCashCurrent": "80726.5625",
      "netPPAndE": "77359.375",
      "CashST": "14054.6875",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  },
  {
      "dateString": "2019-12-31",
      "otherFixed": "94280.78",
      "nonCashCurrent": "88803.1446",
      "netPPAndE": "84517.6546",
      "CashST": "19370.4148",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  },
  {
      "dateString": "2020-06-30",
      "otherFixed": "87851.35075",
      "nonCashCurrent": "82743.8042",
      "netPPAndE": "79767.6314",
      "CashST": "12462.7236",
      "chart_name": "Asset Structure - Composition over Time",
      "chart_number": "4"
  }

]

const parsedateString = timeParse('%Y-%m-%d')
export default assetStructureChartData.map(d => {
  d['date'] = parsedateString(d['dateString'])
  return d
})
